import ErrorDisplay from './ErrorDisplay'

export default ErrorDisplay



// WEBPACK FOOTER //
// ./src/components/ErrorDisplay/index.js